const locale = {
  placeholder: 'Izaberite vreme',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/sr_RS.js